import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Directive({
  selector: '[appFocusClickOnTab]',
})
export class FocusClickOnTabDirective {
  private tabPressed = false;
  private hasActivatedOnTabFocus = false;

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    @Optional() private readonly autocompleteTrigger: MatAutocompleteTrigger
  ) {}

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      this.tabPressed = true;
      this.hasActivatedOnTabFocus = false;
    }
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      this.tabPressed = false;
    }
  }

  @HostListener('focus')
  onFocus(): void {
    if (this.tabPressed && !this.hasActivatedOnTabFocus) {
      this.hasActivatedOnTabFocus = true;
      setTimeout(() => {
        if (this.autocompleteTrigger) {
          this.autocompleteTrigger.openPanel();
        } else {
          this.el.nativeElement.click();
        }
      }, 0);
    }
  }
}
